import { PropertyType, useBidInterestApi, WithAuth } from "../../../../hoc";
import { REQUEST_TYPES, RequestType } from "../constants/auction";

export type UserInfo = {
  name?: string;
  email?: string;
  mobile: string;
};

export type UseRequestImagesParams = {
  withAuth: WithAuth;
  user: UserInfo;
  onSuccess: () => void;
  onError: () => void;
  propertyType: PropertyType;
  requestType: RequestType;
};

export const useRequestImages = ({
  withAuth,
  user,
  onSuccess,
  onError,
  propertyType = "auction_property",
  requestType = REQUEST_TYPES.AUCTION_PROPERTY_IMAGES,
}: UseRequestImagesParams) => {
  const { execute, reset } = useBidInterestApi();

  const requestImages = (listingId: string) => {
    withAuth(() => {
      execute(
        {
          propertyType: propertyType,
          requestType: requestType,
          propertyListingId: listingId,
          userMobile: user.mobile,
          userEmail: user.email,
          userName: user.name,
        },
        { onSuccess, onError },
      );
    })();
  };

  return { requestImages, reset };
};
